import { ApiResponse } from 'apisauce';
import { WorkloadTask } from 'shovel-lib/types';
import { network } from './network';
import {
  BatchTaskEstimationRequest,
  SetDueDateForSelection,
  SetDueTimeForSelection,
  TasksCategorizationRequest,
  TasksEstimationByCategoryRequest
} from '@state/task/types';

const basePath = (semesterId: number) => `/semesters/${semesterId}/tasks`;

interface TaskListApi {
  setTasksDueDate: (semesterId: number, request: SetDueDateForSelection) => Promise<ApiResponse<WorkloadTask[]>>;
  setTasksDueTime: (semesterId: number, request: SetDueTimeForSelection) => Promise<ApiResponse<WorkloadTask[]>>;
  tasksCategorization: (semesterId: number, request: TasksCategorizationRequest) => Promise<ApiResponse<WorkloadTask[]>>;
  tasksEstimationByCategory: (
    semesterId: number,
    request: TasksEstimationByCategoryRequest
  ) => Promise<ApiResponse<WorkloadTask[]>>;
  estimateTasks: (semesterId: number, request: BatchTaskEstimationRequest) => Promise<ApiResponse<WorkloadTask[]>>;
}

const setTasksDueDate = (semesterId: number, request: SetDueDateForSelection) =>
  network.post<WorkloadTask[]>(`${basePath(semesterId)}/set-due-date`, request);

const setTasksDueTime = (semesterId: number, request: SetDueTimeForSelection) =>
  network.post<WorkloadTask[]>(`${basePath(semesterId)}/set-due-time`, request);

const tasksCategorization = (semesterId: number, request: TasksCategorizationRequest) =>
  network.post<WorkloadTask[]>(`${basePath(semesterId)}/categorize`, request);

const tasksEstimationByCategory = (semesterId: number, request: TasksEstimationByCategoryRequest) =>
  network.post<WorkloadTask[]>(`${basePath(semesterId)}/estimate-by-category`, request);

const estimateTasks = (semesterId: number, request: BatchTaskEstimationRequest) =>
  network.post<WorkloadTask[]>(`${basePath(semesterId)}/estimate`, request);

export const taskListApi: TaskListApi = {
  setTasksDueDate,
  setTasksDueTime,
  tasksCategorization,
  tasksEstimationByCategory,
  estimateTasks
};
